import { Action, Module, Mutation, VuexModule, getModule } from 'vuex-module-decorators';
import Search from '@/api/search';
import store from '@/store/index';
import date from '@/common/utils/date';
import { QueryParameters, SearchResponse } from '@/api/types';
import { isCompletedOrClosed } from '@/common/utils/routes';
import { SearchFilters } from '@/types/search';

function initialState() {
  return {
    searchResults: [],
    visibleItems: [],
    selectedItem: null,
    selectedItemColour: ''
  };
}

@Module({
  namespaced: true,
  name: 'searchMod',
  dynamic: true,
  store
})
export default class SearchModule extends VuexModule {
  searchResults: SearchResponse[] = initialState().searchResults;
  visibleItems: SearchResponse[] = initialState().visibleItems;
  selectedItem: SearchResponse | null = initialState().selectedItem;
  selectedItemColour: string = initialState().selectedItemColour;

  get getSearchResults(): SearchResponse[] {
    return this.searchResults;
  }

  get getVisibleItems(): SearchResponse[] {
    return this.visibleItems;
  }

  get getSelectedItem(): SearchResponse | null {
    return this.selectedItem;
  }

  get getSelectedItemColour(): string {
    return this.selectedItemColour;
  }

  @Mutation
  private SET_SEARCH_RESULTS(results: SearchResponse[]) {
    this.searchResults = results;
  }

  @Mutation
  public RESET_SEARCH_RESULTS() {
    this.searchResults = initialState().searchResults;
    this.visibleItems = initialState().visibleItems;
    this.selectedItem = initialState().selectedItem;
    this.selectedItemColour = initialState().selectedItemColour;
  }

  @Mutation
  public SET_VISIBLE_ITEMS(items: SearchResponse[]) {
    this.visibleItems = items;
  }

  @Mutation
  public SET_SELECTED_ITEM(item: SearchResponse | null) {
    this.selectedItem = item;
  }

  @Mutation
  public SET_SELECTED_ITEM_COLOUR(colour: string) {
    this.selectedItemColour = colour;
  }

  @Action
  public async fetchSearchResults(searchFilters: SearchFilters): Promise<void> {
    const routeQueryParameters: QueryParameters = {
      startDateTimeUtc: date.startOfDay(new Date(searchFilters.dateFrom)),
      endDateTimeUtc: date.endOfDay(new Date(searchFilters.dateTo)),
      searchTerm: searchFilters.searchText
    };

    const results = await Search.GetReferenceData(routeQueryParameters);
    const vehicleInRoutes = results
      .filter((item) => {
        if (item.deliveryRunReference && !isCompletedOrClosed(item.routeStatus)) {
          return item;
        }
      })
      .map((item) => item.registrationNumber);

    const validResults = results.filter((item) => {
      if (
        item.deliveryRunReference ||
        (!item.deliveryRunReference && !vehicleInRoutes.includes(item.registrationNumber))
      ) {
        return item;
      }
    });
    this.SET_SEARCH_RESULTS(validResults);
  }
}

export const searchMod = getModule(SearchModule);
